import { z } from "zod";

export const transferEventAcExpoSchema = z.object({
  connectId: z.string().length(10, "Veuillez entrer un Id Connect’Events"),
  eventRef: z.string().min(1, "Veuillez entrer une référence"),
});

export const transferEventAcExpoDefaultValues = {
  connectId: "",
  eventRef: "",
};

export type TransferEventAcExpoForm = z.infer<typeof transferEventAcExpoSchema>;
